import type { InputFormatter } from "../types";

/**
 * Numeric formatter - allows only digits.
 * Strips any non-digit characters from input.
 */
export const numericFormatter: InputFormatter = {
  format: (value) => value.replace(/\D/g, ""),
  parse: (input) => input.replace(/\D/g, ""),
  keyboardType: "numeric",
  autoCapitalize: "none",
};
